import { render, staticRenderFns } from "./personnelList.vue?vue&type=template&id=664225aa&scoped=true"
import script from "./personnelList.vue?vue&type=script&lang=js"
export * from "./personnelList.vue?vue&type=script&lang=js"
import style0 from "./personnelList.vue?vue&type=style&index=0&id=664225aa&prod&lang=less&scoped=true"
import style1 from "./personnelList.vue?vue&type=style&index=1&id=664225aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664225aa",
  null
  
)

export default component.exports